import React from 'react'
import { Col, Row } from "react-bootstrap"
import { Link } from "react-router-dom"

const AdminAllOrdersItem = ({ item }) => {

    return (
        <div className='shadow mx-3'>
            <Link to={`/admin/orders/${item._id}`} className="dark-color my-2 px-1 col-12">
                <Row className='d-flex align-items-center justify-content-between mx-3 gray-bg py-3'>
                    <Col lg="4" sm="12">
                        <p className="py-2 fw-bold fs-20 mb-0"> Order No {item.id} </p>
                    </Col>
                    <Col lg="8" sm="12">
                        <Row className="d-flex justify-content-between">
                            <Col sm="4" xs="12">
                                {item.isDelivered === false ? (<p className='orange-color  mb-0'>Not Delivered</p>) : (<p className='text-success mb-0'> Delivered</p>)}
                            </Col>
                            <Col sm="4" xs="12">
                                {item.paymentMethodType === "cash" ? (<p className='mb-0'>Cach</p>) : (<p className='mb-0'> Visa </p>)}
                            </Col>
                            <Col sm="4" xs="12">
                                {item.isPaid === false ? (<p className='orange-color mb-0'>Not Paied</p>) : (<p className='text-success mb-0'> Pied</p>)}
                            </Col >
                        </Row >
                    </Col >
                </Row>
                <Row className='d-flex align-items-center justify-content-between mx-3 py-3'>
                    <p> <strong> User Name : </strong> {item.user.name} </p>
                    <p> <strong> User Email : </strong> {item.user.email} </p>
                    <p> <strong> User Phone : </strong> {item.user.phone} </p>
                    <p> <strong> User Phone : </strong> {item.user.phone} </p>
                    <Col xs="12" className="d-flex justify-content-end">
                        <div className="orange-color fs-20 fw-bold">{item.totalOrderPrice} LE</div>
                    </Col>
                </Row>
            </Link>
        </div>
    )
}

export default AdminAllOrdersItem
